"use strict";
const createSearchStringQuery = search => {
    const query = {
        or: [{ '$supplier.name$': { iLike: `%${search.replace(' ', '%')}%` } }],
    };
    const reportNumber = Number.parseInt(search, 10) || undefined;
    if (reportNumber) {
        query.or.push({ reportNumber: { eq: reportNumber } });
    }
    return query;
};
module.exports = createSearchStringQuery;
